<template>
  <div
    class="nuvio-login-page"
    :class="{ 'nuvio-keyboard-open': isCredentialKeyboardOpen }"
  >
    <div class="nuvio-login-shell">
      <header class="nuvio-login-header">
        <div class="nuvio-header-brand">
          <img
            v-if="isQfx"
            src="@/assets/img/logos/logo-dark.png"
            width="60"
            class="nuvio-panel-logo"
            height="auto"
            style="margin-bottom: 0px;margin-top: 10px;"
          />
          <img
            v-else
            src="@/assets/img/logos/Nuvio_Black.png"
            width="60"
            class="nuvio-brand-logo"
            height="auto"
          />
        </div>

        <div class="nuvio-header-client">
          <div class="nuvio-app-status" :class="appEnvironmentClass">
            <span></span>
            {{ appEnvironmentLabel }} application
          </div>
          <!-- <div
            v-if="
              origin.includes('localhost') ||
              origin.includes('-stg') ||
              origin.includes('-dev')
            "
            class="nuvio-env-badge"
          >
            <span v-if="origin.includes('localhost')">Localhost</span>
            <span v-else-if="origin.includes('-stg')">Staging</span>
            <span v-else>Development</span>
          </div> -->
          <div
            v-if="getOrganizationDetails && getOrganizationDetails.org_logo_url"
            class="nuvio-org-logo"
          >
            <img
              :src="getOrganizationDetails.org_logo_url"
              :alt="getOrganizationDetails.org_name"
            />
          </div>
          <div v-else class="nuvio-org-fallback">
            {{
              getOrganizationDetails
                ? getOrganizationDetails.org_name
                : "Cinema"
            }}
          </div>
        </div>
      </header>

      <main class="nuvio-login-main">
        <section class="nuvio-login-card">
          <aside class="nuvio-brand-panel">
            <div class="nuvio-brand-copy">
              <img
                v-if="isQfx"
                src="@/assets/img/logos/logo-light.png"
                width="60"
                class="nuvio-panel-logo"
                height="auto"
                style="position: relative; left: -30px;"
              />
              <img
                v-else
                src="@/assets/img/logos/Nuvio_White.png"
                width="60"
                class="nuvio-panel-logo"
                height="auto"
              />
              <p>movie . food . entertainment</p>
              <h3>
                Built for movie tickets, food orders, and cinema counters.
              </h3>
              <div class="nuvio-brand-points">
                <span>Ticketing</span>
                <span>Food orders</span>
                <span>Show control</span>
              </div>
              <svg
                class="nuvio-page-watermark nuvio-page-watermark-popcorn"
                viewBox="0 0 120 120"
                aria-hidden="true"
              >
                <path d="M32 42 H88 L80 104 H40 Z"></path>
                <path
                  d="M42 42 C36 34 42 24 51 29 C54 17 70 17 73 29 C82 24 88 34 82 42"
                ></path>
                <path d="M48 52 L52 96"></path>
                <path d="M72 52 L68 96"></path>
                <path d="M32 60 H88"></path>
              </svg>
              <svg
                class="nuvio-page-watermark nuvio-page-watermark-movie"
                viewBox="0 0 120 120"
                aria-hidden="true"
              >
                <rect x="20" y="34" width="80" height="56" rx="12"></rect>
                <path d="M26 34 L40 18 L54 34 L68 18 L82 34 L96 18"></path>
                <path d="M20 51 H100"></path>
                <path d="M42 66 H78"></path>
                <path d="M42 78 H68"></path>
              </svg>
            </div>
          </aside>

          <section class="nuvio-auth-panel">
            <div class="nuvio-auth-heading">
              <span>POS terminal</span>
              <h2>{{ greetingText }}</h2>
              <p>Fast operator sign in for ticketing and food booking.</p>
            </div>

            <template v-if="!isPasswordValidityExpired">
              <div class="nuvio-auth-switch">
                <button
                  type="button"
                  class="nuvio-switch-btn"
                  :class="{ active: authMode == 'pin' }"
                  :aria-pressed="authMode == 'pin'"
                  @click="switchAuthMode('pin')"
                >
                  PIN
                </button>
                <button
                  type="button"
                  class="nuvio-switch-btn"
                  :class="{ active: authMode == 'credentials' }"
                  :aria-pressed="authMode == 'credentials'"
                  @click="switchAuthMode('credentials')"
                >
                  Username
                </button>
              </div>
              <form
                v-if="authMode == 'pin'"
                @submit.prevent.stop="onFormSubmit()"
                class="nuvio-pin-form"
              >
                <div class="nuvio-pin-fields">
                  <div>
                    <label class="nuvio-field-label">User PIN</label>
                    <div
                      class="nuvio-pin-box-wrap"
                      :class="{ active: selectedType == 'userpin' }"
                      @click="focusPinInput('userpin')"
                    >
                      <input
                        @click="onClickInputType('userpin')"
                        maxlength="4"
                        inputmode="numeric"
                        pattern="[0-9]*"
                        v-model="userpin"
                        tabindex="2"
                        type="password"
                        ref="userpin"
                        class="nuvio-pin-native-input"
                        @input="checkLength"
                      />
                      <span
                        v-for="index in 4"
                        :key="'user-pin-box-' + index"
                        class="nuvio-pin-digit-box"
                        :class="{
                          filled: getPinDigit(userpin, index - 1),
                          focused: isPinDigitFocused('userpin', index - 1)
                        }"
                      >
                        {{ getPinDigit(userpin, index - 1) ? "•" : "" }}
                      </span>
                    </div>
                  </div>
                  <div>
                    <label class="nuvio-field-label">Password PIN</label>
                    <div
                      class="nuvio-pin-box-wrap"
                      :class="{ active: selectedType == 'passwordpin' }"
                      @click="focusPinInput('passwordpin')"
                    >
                      <input
                        @click="onClickInputType('passwordpin')"
                        maxlength="4"
                        inputmode="numeric"
                        pattern="[0-9]*"
                        v-model="passwordpin"
                        tabindex="3"
                        type="password"
                        ref="userpasswordpin"
                        class="nuvio-pin-native-input"
                        @input="limitPin('passwordpin')"
                      />
                      <span
                        v-for="index in 4"
                        :key="'password-pin-box-' + index"
                        class="nuvio-pin-digit-box"
                        :class="{
                          filled: getPinDigit(passwordpin, index - 1),
                          focused: isPinDigitFocused('passwordpin', index - 1)
                        }"
                      >
                        {{ getPinDigit(passwordpin, index - 1) ? "•" : "" }}
                      </span>
                    </div>
                  </div>
                </div>

                <div class="nuvio-pin-pad">
                  <button
                    v-for="(value, index) in phone_value"
                    :key="'pin-key-' + index"
                    type="button"
                    class="nuvio-key"
                    :class="{
                      'nuvio-key-muted':
                        value.name == '' || index == phone_value.length - 1
                    }"
                    @click.prevent.stop="
                      index == phone_value.length - 1
                        ? onSliceNUmber()
                        : value.name == ''
                        ? clearInput()
                        : onClickNumber(index)
                    "
                  >
                    <span v-if="value.name != ''">{{ value.name }}</span>
                    <span v-else>C</span>
                  </button>
                </div>

                <button type="submit" class="nuvio-primary-btn w-100">
                  Login
                </button>
              </form>

              <form
                v-else
                @submit.prevent.stop="checkOnlyAuthenticator()"
                ref="posloginform"
                class="nuvio-credential-form"
              >
                <div class="nuvio-input-group">
                  <label class="nuvio-field-label">Username</label>
                  <div class="nuvio-input-shell input-material">
                    <img
                      src="@/assets/img/icons/login-user.png"
                      class="login-icon"
                    />
                    <input
                      type="text"
                      v-model="username"
                      placeholder="Username"
                      required="required"
                      autocomplete="off"
                      id="dashusername"
                      ref="dashusername"
                      readonly
                      tabindex="0"
                      @click="openCredentialKeyboard('username')"
                      @keydown.tab.prevent="$refs.dashpassword.focus()"
                      onfocus="this.removeAttribute('readonly');"
                    />
                  </div>
                  <VkeyboardFloat
                    :ID="'dashusername'"
                    :onClickFun="() => toggleCredentialKeyboard('username')"
                  />
                  <Vkeyboard
                    :inputName="'dashusername'"
                    :showOrHide="showUsernameVKeyboard"
                    :initialValue="username"
                    @onChangeEvent="onChangeKeboardData('dashusername')"
                    @onKeyEnter="checkOnlyAuthenticator()"
                    @changeKeyboardInput="username = $event"
                    @onClickClose="closeCredentialKeyboard"
                  />
                </div>

                <div class="nuvio-input-group">
                  <label class="nuvio-field-label">Password</label>
                  <div class="nuvio-input-shell input-material">
                    <img
                      src="@/assets/img/icons/login-password.png"
                      class="login-icon"
                    />
                    <img
                      width="18"
                      height="18"
                      @click="togglePassword()"
                      class="show-password-icon"
                      v-if="passwordType == 'password'"
                      src="@/assets/img/icons/show-password.svg"
                    />
                    <img
                      width="18"
                      height="18"
                      @click="togglePassword()"
                      class="show-password-icon"
                      v-if="passwordType == 'text'"
                      src="@/assets/img/icons/hide-password.svg"
                    />
                    <input
                      :type="passwordType"
                      v-model="password"
                      autocomplete="off"
                      placeholder="Password"
                      readonly
                      tabindex="1"
                      id="dashpassword"
                      ref="dashpassword"
                      @click="openCredentialKeyboard('password')"
                      onfocus="this.removeAttribute('readonly');"
                      @keydown.tab.prevent="$refs.loginbutton.focus()"
                    />
                  </div>
                  <VkeyboardFloat
                    :ID="'dashpassword'"
                    :onClickFun="() => toggleCredentialKeyboard('password')"
                  />
                  <Vkeyboard
                    :inputName="'dashpassword'"
                    :initialValue="password"
                    :showOrHide="showPassVKeyboard"
                    :hideTypingInput="true"
                    @onChangeEvent="onChangeKeboardData('dashpassword')"
                    @onKeyEnter="checkOnlyAuthenticator()"
                    @changeKeyboardInput="password = $event"
                    @onClickClose="closeCredentialKeyboard"
                  />
                </div>

                <button
                  class="nuvio-primary-btn w-100"
                  type="submit"
                  ref="loginbutton"
                >
                  <span>{{ $t("signin") }}</span>
                </button>
              </form>
            </template>
            <template v-else>
              <PosResetPasswordPin
                :prefillUserPin="userpin"
                :currentUserId="currentUserId"
                @reset-success="handleResetPinSuccess"
              />
            </template>
          </section>
        </section>
      </main>
    </div>

    <TwoFAModal
      :openModal="showModal"
      @onConfirm="confirmation"
      @onClose="ResetVariable"
      :onlyAuthenticator="onlyAuthenticator"
    ></TwoFAModal>

    <PosLoginOTP
      :openModal="showOtpModal"
      @otp-verified="onVerifedOtp"
    ></PosLoginOTP>
  </div>
</template>

<script>
// import languages from "@/helper/Languages";
// import i18n from "@/plugins/i18n";
import UserService from "@/services/UserService";
import MasterService from "@/services/MasterService";
import PosService from "@/services/PosService";
import PosHeader from "@/components/Partials/posHeader.vue";
import TwoFAModal from "@/components/Partials/2FAModal.vue";
import PosLoginOTP from "@/components/Partials/PosLoginOTP.vue";
import { backendSocket } from "@/main.js";
import Vkeyboard from "@/components/Partials/Vkeyboard.vue";
import VkeyboardFloat from "@/components/Partials/keyboardFloatingToggle.vue";
import { BASEURL } from "@/config/index";
import axios from "axios";
import { getHardwareId, getResourceUsageInfo } from "@/socket.io/init";
import { EventBus } from "@/main";
import { CLIENT_NAMES_OBJ, CLIENT_NAME } from "@/helper/Role";
import { getWorkstation } from "@/util/indexDb/workstationIndexDb";
import PosResetPasswordPin from "./PosResetPasswordPin.vue";

export default {
  components: {
    PosHeader,
    TwoFAModal,
    Vkeyboard,
    VkeyboardFloat,
    PosLoginOTP,
    PosResetPasswordPin,
  },
  data() {
    return {
      showVKeyboard: false,
      showPassVKeyboard: false,
      showUsernameVKeyboard: false,
      origin: window && window.origin ? window.origin : "",
      authMode: "pin",
      username: "",
      password: "",
      onlyAuthenticator: false,

      userpin: "",
      passwordpin: "",
      selectedType: "userpin",

      // username: "jaymewada",
      // password: "123456",

      // username: "gogopos",
      // password: "password123"

      phone_value: [
        { name: "1" },
        { name: "2" },
        { name: "3" },
        { name: "4" },
        { name: "5" },
        { name: "6" },
        { name: "7" },
        { name: "8" },
        { name: "9" },
        { name: "" },
        { name: "0" },
        { name: "<-" }
      ],

      showNotification: false,
      // languages,
      hardware_id: null,
      selectedLanguage: "English",
      showModal: false,
      showOtpModal: false,
      secretCode: null,
      verficationId: null,
      otpValue: null,
      DeviceUniqueCode: "",
      passwordType: "password",
      cinemasList: [],
      posShiftLog: {
        paymentTypes: [],
        grandTotal: 0,
        cine_include_shift_close: null,
        usl_id: null,
        user_shift_id: null
      },
      isPasswordValidityExpired: false,
      currentUserId: null,
    };
  },
  computed: {
    isQfx() {
      return CLIENT_NAME.QFX == this.CLIENT_SETUP_NAME;
    },
    getOrganizationDetails() {
      return this.$store.getters.getOrganizationDetails;
    },
    TEST_SETUP() {
      return this.$store.getters.TEST_SETUP;
    },
    USE_TIM_INTEGRATION() {
      return this.$store.getters.USE_TIM_INTEGRATION;
    },
    appEnvironmentLabel() {
      return this.$store.getters.TEST_SETUP == "N" ? "Live" : "Demo";
    },
    appEnvironmentClass() {
      return this.$store.getters.TEST_SETUP == "N" ? "is-live" : "is-demo";
    },
    greetingText() {
      const hour = new Date().getHours();
      if (hour >= 4 && hour < 12) return "Good morning!";
      if (hour >= 12 && hour < 16) return "Good afternoon!";
      return "Good evening!";
    },
    isCredentialKeyboardOpen() {
      return (
        this.authMode == "credentials" &&
        (this.showUsernameVKeyboard || this.showPassVKeyboard)
      );
    }
  },
  mounted() {
    this.checkUserLoggedInFunction();
    this.DeviceUniqueCode = window.localStorage.getItem("deiviceUniqueCode")
      ? window.localStorage.getItem("deiviceUniqueCode")
      : "";

    if (this.$ipcRenderer) {
      this.$ipcRenderer.send("SET_HOME_PAGE");
      if (this.getOrganizationDetails) {
        this.$ipcRenderer.send("SET_ORG_DETAILS", this.getOrganizationDetails);
      }
    } else {
      console.log("Not running inside Electron");
    }
    this.$nextTick(() => {
      if (this.$refs["userpin"]) {
        this.$refs["userpin"].focus();
      }
    });
  },
  methods: {
    focusInput() {
      setTimeout(() => {
        if (this.$refs["userpin"]) {
          this.$refs["userpin"].focus();
        }
      }, 500);
      this.passwordpin = "";
      this.userpin = "";
    },
    hideLoginViaPin() {
      if (this.$refs["loginViaPin"] && this.$refs["loginViaPin"].hide) {
        this.$refs["loginViaPin"].hide();
      }
    },
    async checkPasswordPinValidity() {
      if (!this.userpin) return this.$toasted.show("User Pin required");

      try {
        const response = await UserService.checkPosUserPasswordPinValidity({
          user_pin: this.userpin,
        });
        const { data } = response;
        if (!data || (!data["status"] && !data["Records"])) {
          return this.$toasted.show(
            data["message"] || "User pin validity check failed"
          );
        }

        if (
          !data["status"] &&
          data["Records"] &&
          data["Records"]["is_password_expired"] &&
          data["Records"]["user_id"]
        ) {
          this.isPasswordValidityExpired = true;
          this.currentUserId = data["Records"]["user_id"];
        }
      } catch (error) {
        console.log(error);
        this.$toasted.show("Something went wrong while validity user pin");
      }
    },
    handleResetPinSuccess(data) {
      console.log(data);
      this.isPasswordValidityExpired = false;
    },
    switchAuthMode(mode) {
      this.authMode = mode;
      this.showPassVKeyboard = false;
      this.showUsernameVKeyboard = false;
      this.$nextTick(() => {
        if (mode == "pin") {
          this.selectedType = "userpin";
          if (this.$refs["userpin"]) {
            this.$refs["userpin"].focus();
          }
        } else if (this.$refs["dashusername"]) {
          this.$refs["dashusername"].focus();
        }
      });
    },
    toggleCredentialKeyboard(type) {
      if (type == "username") {
        const shouldOpen = !this.showUsernameVKeyboard;
        this.showUsernameVKeyboard = shouldOpen;
        this.showPassVKeyboard = false;
        if (shouldOpen) this.ensureCredentialInputVisible("dashusername");
      } else {
        const shouldOpen = !this.showPassVKeyboard;
        this.showPassVKeyboard = shouldOpen;
        this.showUsernameVKeyboard = false;
        if (shouldOpen) this.ensureCredentialInputVisible("dashpassword");
      }
    },
    openCredentialKeyboard(type) {
      this.onClickInputHandler(type);
      if (type == "username") {
        this.showUsernameVKeyboard = true;
        this.showPassVKeyboard = false;
        this.ensureCredentialInputVisible("dashusername");
      } else {
        this.showUsernameVKeyboard = false;
        this.showPassVKeyboard = true;
        this.ensureCredentialInputVisible("dashpassword");
      }
    },
    closeCredentialKeyboard() {
      this.showUsernameVKeyboard = false;
      this.showPassVKeyboard = false;
    },
    ensureCredentialInputVisible(refName) {
      this.$nextTick(() => {
        const input = this.$refs[refName];
        if (input && input.scrollIntoView) {
          input.scrollIntoView({ block: "center", behavior: "smooth" });
          input.focus();
        }
      });
    },
    getActiveLoginPayload() {
      if (this.authMode == "pin") {
        return {
          username: this.userpin,
          password: this.passwordpin
        };
      }
      return {
        username: this.username,
        password: this.password
      };
    },
    getPinDigit(value, index) {
      return String(value || "").charAt(index);
    },
    isPinDigitFocused(type, index) {
      if (this.selectedType != type) return false;
      const value = type == "userpin" ? this.userpin : this.passwordpin;
      const activeIndex = Math.min(String(value || "").length, 3);
      return index == activeIndex;
    },
    limitPin(type) {
      const pinValue = String(this[type] || "")
        .replace(/\D/g, "")
        .slice(0, 4);
      this[type] = pinValue;
      return pinValue;
    },
    focusPinInput(type) {
      this.onClickInputType(type);
      this.$nextTick(() => {
        const refName = type == "userpin" ? "userpin" : "userpasswordpin";
        if (this.$refs[refName]) {
          this.$refs[refName].focus();
        }
      });
    },
    async checkLength() {
      let stringText = this.limitPin("userpin");
      if (
        stringText &&
        stringText.length > 3 &&
        this.$refs["userpasswordpin"]
      ) {
        this.$refs["userpasswordpin"].focus();
      }
    },
    onChangeKeboardData(refs) {
      if (refs) {
        this.$refs[refs].focus();
        this.$forceUpdate();
      }
    },
    onClickInputHandler(event) {
      if (this.$socket) {
        this.$socket.emit("set_org_details", this.getOrganizationDetails);
      } else {
        console.log("no socket");
      }
      if (this.showUsernameVKeyboard && event == "password") {
        this.showUsernameVKeyboard = false;
        this.showPassVKeyboard = true;
      } else if (this.showUsernameVKeyboard && event == "username") {
        this.showUsernameVKeyboard = false;
        this.showPassVKeyboard = false;
      } else if (this.showPassVKeyboard && event == "username") {
        this.showUsernameVKeyboard = true;
        this.showPassVKeyboard = false;
      } else if (this.showPassVKeyboard && event == "password") {
        this.showUsernameVKeyboard = false;
        this.showPassVKeyboard = false;
      }
    },
    ResetVariable: function(value) {
      this.secretCode = "";
      this.showModal = value;
    },
    onFormSubmit: function() {
      console.log("fsdfsdfs", "fsfsdf", this.userpin, this.passwordpin);
      if (this.userpin && this.passwordpin) {
        this.check2FAIsEnabled();
      } else {
        this.$toasted.show("Please enter both PINs");
      }
    },
    confirmation: function(values) {
      console.log("values", values);
      console.log("showModal", this.showModal);
      if (this.showModal && values) {
        this.secretCode = values;
        this.onPosLogin();
      }
    },
    onVerifedOtp: function(values) {
      console.log("values", values);
      console.log("showOtpModal", this.showOtpModal);
      if (this.showOtpModal && values) {
        this.otpValue = values;
        this.onPosLogin();
      }
    },
    async canLoginForWorkstation(accessType) {
      const workstationType = await getWorkstation();

      if (
        workstationType == "FNB" &&
        !["FNBONLY", "SUPER"].includes(accessType)
      ) {
        this.$toasted.show(
          "Only FNB or BOFNB users can login on FNB workstation."
        );
        return false;
      }

      if (
        workstationType == "BO" &&
        !["POSONLY", "SUPER"].includes(accessType)
      ) {
        this.$toasted.show(
          "Only POS or BOFNB users can login on BO workstation."
        );
        return false;
      }

      return true;
    },
    userShiftStart: async function(shiftUserData, token) {
      this.showLoading();
      // await commit("SET_USER_SHIFT_DETAILS", payload);

      let hardwareMacAddress = window.localStorage.getItem(
        "hardware_mac_address"
      );
      let hardwareId = window.localStorage.getItem("deiviceUniqueCode");
      // functionality remaining
      if (!hardwareId || !hardwareMacAddress) {
        var userAgent = navigator.userAgent.toLowerCase();
        if (userAgent.indexOf(" electron/") > -1) {
          let sys_info = await getResourceUsageInfo();
          const key = Object.keys(sys_info.macAddress)[0];
          hardwareMacAddress = sys_info.macAddress[key].mac;
        }
      }
      // functionality remaining
      let requestPayload = {
        ...this.posShiftLog,
        hardware_id: window.localStorage.getItem("HWUID")
          ? window.localStorage.getItem("HWUID")
          : window.localStorage.getItem("deiviceUniqueCode")
          ? window.localStorage.getItem("deiviceUniqueCode")
          : null,
        hardware_name: window.localStorage.getItem("hardware_name")
          ? window.localStorage.getItem("hardware_name")
          : null,
        hardware_mac_address: window.localStorage.getItem(
          "hardware_mac_address"
        )
          ? window.localStorage.getItem("hardware_mac_address")
          : hardwareMacAddress
          ? hardwareMacAddress
          : null
      };

      var config = {
        method: "post",
        url: `${BASEURL}/api/pos/pos-user-shift-log`,
        headers: {
          "Content-Type": "application/json",
          Authorization: token
        },
        data: JSON.stringify(requestPayload)
      };

      axios(config)
        .then(response => {
          const { data } = response;
          if (data && data.status) {
            this.posShiftLog = { ...this.posShiftLog, ...data.Records };

            if (data.Records.float_amount) {
              window.localStorage.setItem("FLOAT_AMOUNT_ADDED", "Y");
            } else {
              window.localStorage.setItem("FLOAT_AMOUNT_ADDED", "N");
            }

            if (shiftUserData["cine_include_float_amount"] == "N") {
              window.localStorage.setItem("FLOAT_AMOUNT_ADDED", "Y");
            }
            window.localStorage.setItem(
              "USER_SHIFT_DATA",
              JSON.stringify(this.posShiftLog)
            );
            window.localStorage.setItem(
              "USER_SHIFT_ID",
              this.posShiftLog.usl_id
            );

            if (!data.Records["inserted_new"]) {
              // USE WHEN WE NEED TO FORCE CLOSE SHIFT
              // router.replace({
              //     path: "close-shift"
              // });

              if (
                shiftUserData["page_name"] &&
                shiftUserData["page_name"] == "FNB_LOGIN"
              ) {
                console.log("route to pos-fnb");
                this.$router.replace({
                  path: "/pos-fnb"
                });
              } else {
                this.$router.replace({
                  path: "/pos-booking"
                });
              }
            } else if (
              shiftUserData["page_name"] &&
              shiftUserData["page_name"] == "FNB_LOGIN"
            ) {
              if (
                shiftUserData["cine_include_float_amount"] &&
                shiftUserData["cine_include_float_amount"] == "Y"
              ) {
                console.log("route to pos-fnb-cash");
                this.$router.replace({
                  path: "/pos-cash-input",
                  query: { nextRoute: "FNB_LOGIN" }
                });
              } else {
                console.log("route to pos-fnb");
                this.$router.replace({
                  path: "/pos-fnb"
                });
              }
            } else if (
              shiftUserData["cine_include_float_amount"] &&
              shiftUserData["cine_include_float_amount"] == "Y"
            ) {
              this.$router.replace({
                path: "/pos-cash-input",
                query: { nextRoute: "POS_LOGIN" }
              });
            } else {
              this.$router.replace({
                path: "/pos-booking"
              });
            }
          } else {
          }
        })
        .catch(error => {})
        .finally(() => {
          setTimeout(() => {
            this.hideLoading();
          }, 1000);
        });
    },
    check2FAIsEnabled: function() {
      this.showLoading();
      let payload = this.getActiveLoginPayload();

      if (this.authMode == "pin") {
        payload["type"] = "pin";
      }

      console.log({ payload });
      UserService.Check2FAEnabled(payload)
        .then(response => {
          const { data } = response;
          if (data && data.status) {
            if (data.isEnabled) {
              this.hideLoginViaPin();
              this.showModal = !this.showModal;
              // this.$refs["Ref-2fa-Modal"].show();
            } else if (!isNaN(String(data["verification_id"]))) {
              this.verficationId = data["verification_id"];
              this.hideLoginViaPin();
              this.showOtpModal = !this.showOtpModal;
            } else {
              //GENERATEOPT
              //TOKEN - USERNAME PASSWORD USER_ID
              this.onPosLogin();
            }
          } else {
            this.$toasted.show(data.message);
            if (
              data &&
              !data.status &&
              data.Records &&
              data.Records.is_password_expired
            ) {
              this.isPasswordValidityExpired = true;
              this.currentUserId = data["Records"]["user_id"];
            }
          }
        })
        .catch(err => {
          console.log("Error:", err);
          this.$toasted.show("Invalid Login");
        })
        .finally(() => {
          setTimeout(() => {
            this.hideLoading();
          }, 1000);
        });
    },
    checkOnlyAuthenticator: function() {
      this.showLoading();
      let payload = {
        username: this.username
      };
      UserService.CheckOnlyAuthenticatorEnabled(payload)
        .then(resp => {
          const { data } = resp;
          if (data.status) {
            if (data.isEnabled) {
              this.onlyAuthenticator = true;
              this.showModal = !this.showModal;
            } else {
              if (!this.password) {
                this.$toasted.show("Please enter your password");
              } else {
                this.check2FAIsEnabled();
              }
            }
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(err => {
          console.log(err);
        })
        .finally(() => {
          setTimeout(() => {
            this.hideLoading();
          }, 1000);
        });
    },
    checkUserLoggedInFunction() {
      UserService.checkUserLoggedIn({}).then(response => {
        const { data } = response;
        let localStorageData = window.localStorage;
        let HashId = localStorage.getItem("JWT_TOKEN");
        let userInfo = localStorageData.getItem("USER_INFO");
        let accessLimitation = localStorageData.getItem("USER_ROLE_NAME");
        if (data.status && HashId) {
          console.log("testing here");
          if (accessLimitation) {
            if (accessLimitation == "SUPER" || accessLimitation == "POSONLY") {
              this.$router.push({
                path: "pos-booking"
              });
            } else if (accessLimitation == "FNBONLY") {
              this.$router.push({
                path: "pos-fnb"
              });
            } else {
              this.onLogout();
              this.$toasted.show("Please Login Again!");
            }
          } else {
            console.log("testing here12");
            if (userInfo && userInfo.role_id == 4) {
              this.$router.replace({
                path: "pos-booking"
              });
            } else if (userInfo && userInfo.role_id == 8) {
              this.$router.replace({
                path: "pos-fnb"
              });
            } else if (
              userInfo &&
              userInfo.role_id != 8 &&
              userInfo.role_id != 4
            ) {
              this.onLogout();
            }
          }
        } else if (data.errorCode == 409) {
          this.onLogout();
        }
      });
    },
    pingHardware() {
      var userAgent = navigator.userAgent.toLowerCase();
      if (userAgent.indexOf(" electron/") > -1) {
        if (backendSocket && backendSocket.connected) {
          backendSocket.emit("hardware-connected");
        }
      }
    },
    onLogout: function(url) {
      let localStorageData = window.localStorage;
      UserService.removeToken()
        .then(res => {
          const { data } = res;
          if (data.status == true) {
            window.localStorage.removeItem("JWT_TOKEN");
            window.localStorage.clear();
            this.$router.push({ path: "/" });
          } else {
            window.localStorage.removeItem("JWT_TOKEN");
            window.localStorage.clear();
            this.$router.push({ path: "/" });
            this.$toasted.show(data.message);
          }
        })
        .catch(err => {
          this.$router.push({ path: "/" });
          this.$toasted.show("Token not removed");
        });
    },
    getOrgnizationLogo: function() {
      PosService.getOrgDetails()
        .then(response => {
          const { data } = response;
          if (data && data.status && data.Records.length > 0) {
          } else {
            // this.$toasted.show(data.message);
          }
        })
        .catch(error => {
          this.$toasted.show(error);
        });
    },
    onClickLoginViaPin: function() {
      this.switchAuthMode("pin");
    },
    onClickInputType: function(type) {
      this.selectedType = type;
    },
    onClickNumber: function(number) {
      const keyValue = this.phone_value[number]
       
        ? this.phone_value[number].name
       
        : "";
      if (!keyValue || keyValue == "<-") return;
      if (this.selectedType == "userpin") {
        if (this.userpin && this.userpin.length >= 4) {
          this.onClickInputType("passwordpin");
          this.$refs["userpasswordpin"].focus();
        } else {
          this.userpin = String(this.userpin + keyValue).slice(0, 4);
          if (
            this.userpin &&
            this.userpin.length >= 4 &&
            this.$refs["userpasswordpin"]
          ) {
            this.onClickInputType("passwordpin");
            this.$refs["userpasswordpin"].focus();
          }
        }
      } else if (this.selectedType == "passwordpin") {
        if (this.passwordpin && this.passwordpin.length >= 4) return;
        this.passwordpin = String(this.passwordpin + keyValue).slice(0, 4);
      }
    },
    onSliceNUmber: function() {
      if (this.selectedType == "userpin") {
        if (this.userpin.length > 0) {
          this.userpin = this.userpin.slice(0, -1);
        }
        if (this.userpin.length == 0) {
          this.userpin = "";
        }
      } else if (this.selectedType == "passwordpin") {
        if (this.passwordpin.length > 0) {
          this.passwordpin = this.passwordpin.slice(0, -1);
        }
        if (this.passwordpin.length == 0) {
          this.passwordpin = "";
        }
      }
    },
    clearInput: function() {
      if (this.selectedType == "userpin") {
        this.userpin = "";
      } else if (this.selectedType == "passwordpin") {
        this.passwordpin = "";
      }
    },
    getAllCinemas: function() {
      MasterService.GetAllCinema({})
        .then(response => {
          this.cinemasList = [];
          const { data } = response;
          if (data && data.status && data.Records && data.Records.length > 0) {
            this.cinemasList = [...data.Records];
          } else {
            this.$toasted.show("Something went wrong on cinema fetch");
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    onPosLogin: function() {
      window.localStorage.setItem("cacheMode", "Y");
      let loginPayload = this.getActiveLoginPayload();
      if (!loginPayload.username || String(loginPayload.username).length == 0) {
        this.$toasted.show("Please provide username");
        return;
      } else if (
        (!loginPayload.password || String(loginPayload.password).length == 0) &&
        !this.onlyAuthenticator
      ) {
        this.$toasted.show("Please provide password");
        return;
      } else {
        this.showLoading();
        let payload = {
          username: loginPayload.username,
          password: loginPayload.password,
          onlyAuthenticator: this.onlyAuthenticator
        };
        let checkAccess = "";
        if (this.secretCode && this.secretCode.length > 0) {
          payload.secretCode = this.secretCode;
        }
        if (this.verficationId && this.otpValue.length > 0) {
          payload["verification_id"] = this.verficationId;
          payload["otp"] = this.otpValue;
        }
        if (this.hardware_id) {
          payload["hardware_id"] = this.hardware_id;
        }
        UserService.LoginUser(payload)
          .then(async response => {
            const { data } = response;
            if (data.status) {
              this.secretCode = "";
              this.showModal = false;
              this.hideLoginViaPin();
              let finalObj = {};
              let PromiseArray = this.usersArray.map(x => {
                finalObj[x] = data.data.user[x] || null;
              });
              // console.log("finalObj", finalObj);
              await Promise.all(PromiseArray);

              this.pingHardware();

              //CHECK LIMITATION ON ACCESS
              checkAccess = this.checkPosAccess(data.data.user);
              // console.log(checkAccess, "checkAccess");
              const canLogin = await this.canLoginForWorkstation(checkAccess);
              if (!canLogin) {
                return;
              } else if (
                !checkAccess &&
                [4, 8].includes(data.data.user.role_id)
              ) {
                this.$toasted.show("User has No Access!");
              } else if (data.data.user && data.data.user.shift_id) {
                window.localStorage.setItem(
                  "USER_INFO",
                  finalObj ? JSON.stringify(finalObj) : {}
                );

                window.localStorage.setItem(
                  "DFLT_USINFO",
                  finalObj ? JSON.stringify(finalObj) : {}
                );

                // HASH TOKEN KEY: BR-BRIJ HS: HASH ID =BRHSID

                // this.$store.dispatch("onSetAndSendLog", {
                //   cinema_id: finalObj.cinema_id,
                //   user_id: finalObj.user_id,
                //   action: "POS User Logged In",
                //   page_name: "POS LOGIN",
                //   api_name: window.location.hash,
                // });
                // BRLF: BRIJ LOGIN FROM
                window.localStorage.setItem("JWT_TOKEN", data.data.token);

                if (
                  data.hasOwnProperty("cinema_reponse") &&
                  data.cinema_reponse &&
                  data.cinema_reponse.length > 0 &&
                  data.cinema_reponse[0].cinema_id &&
                  ["4", "8"].includes(String(data.data.user.role_id))
                ) {
                  window.localStorage.setItem(
                    "cinema_id",
                    data.cinema_reponse[0].cinema_id
                  );

                  if (data.cinema_reponse[0].cinema_id) {
                    this.$store.dispatch("fetchCinemaSpecificSettings", {
                      cinema_id: data.cinema_reponse[0].cinema_id
                    });
                  }
                } else if (
                  ["4", "8"].includes(String(data.data.user.role_id))
                ) {
                  window.localStorage.setItem("cinema_id", finalObj.cinema_id);

                  if (finalObj.cinema_id) {
                    this.$store.dispatch("fetchCinemaSpecificSettings", {
                      cinema_id: finalObj.cinema_id
                    });
                  }
                }

                window.localStorage.setItem(
                  "IS_SHIFT_CLOSE",
                  data.data.user.cine_include_shift_close
                );
                // BRIJ CINE FLOAT AMOUT

                // POS USER ACCESS LIMITATIONS POS/FNB
                // POSONLY FNBONLY SUPER
                window.localStorage.setItem("USER_ROLE_NAME", checkAccess);

                window.localStorage.setItem(
                  "IS_INCLUDE_FLOAT_AMOUNT",
                  data.data.user["cine_include_float_amount"]
                );

                if (checkAccess == "FNBONLY") {
                  window.localStorage.setItem("isBOCalculator", false);
                  await this.userShiftStart(
                    {
                      usl_id: data.data.user.user_id,
                      user_shift_id: data.data.user.shift_id,
                      cine_include_shift_close:
                        data.data.user.cine_include_shift_close,
                      cine_include_float_amount:
                        data.data.user.cine_include_float_amount,
                      page_name: "FNB_LOGIN"
                    },
                    data.data.token
                  );
                } else {
                  window.localStorage.setItem("isBOCalculator", true);
                  await this.userShiftStart(
                    {
                      usl_id: data.data.user.user_id,
                      user_shift_id: data.data.user.shift_id,
                      cine_include_shift_close:
                        data.data.user.cine_include_shift_close,
                      cine_include_float_amount:
                        data.data.user.cine_include_float_amount
                    },
                    data.data.token
                  );
                }
                console.log("this.hardware_id", this.hardware_id);

                var userAgent = navigator.userAgent.toLowerCase();
                if (userAgent.indexOf(" electron/") > -1) {
                  if (backendSocket && backendSocket.connected) {
                    backendSocket.emit("on_user_login", {
                      user: data.data.user,
                      hardware_id: this.hardware_id
                    });
                  }
                }
                // console.log(data.data.user, "data.userthing");

                // this.$store.dispatch("onUserLogin", data.data.user);

                // functionality remaining
                if (!this.authorizeClient(CLIENT_NAMES_OBJ.no_login_print)) {
                  let loginData = {
                    cine_name: "",
                    first_name: "",
                    last_name: "",
                    role_name: "",
                    up_employee_code: "",
                    current_login_date_time: "",
                    float_amount: ""
                  };
                  if (data.data.user) {
                    Object.keys(loginData).forEach(userKeys => {
                      loginData[userKeys] = data.data.user[userKeys];
                    });
                  }
                  console.log(loginData, "loginData");
                  setTimeout(() => {
                    if (this.$socket) {
                      this.$socket.emit("on_print_ticket", {
                        cinema_id: data.data.user.cinema_id,
                        baseurl: BASEURL,
                        ttype: "empire-login-ticket",
                        openDrawer: "N",
                        loginDateTime: JSON.stringify(loginData)
                      });
                    }
                  }, 2000);
                }

                if (this.USE_TIM_INTEGRATION == "Y") {
                  this.initTimMachine();
                }

                this.sendAuditLogs({
                  cinema_id: finalObj.cinema_id,
                  user_id: finalObj.user_id,
                  action: `POS User Logged In - (${checkAccess})`,
                  page_name: "POS LOGIN",
                  api_name: window.location.hash
                });
              } else if (data.data.user.role_name == "Kitchen Manager") {
                window.localStorage.setItem(
                  "USER_INFO",
                  finalObj ? JSON.stringify(finalObj) : {}
                );

                window.localStorage.setItem(
                  "DFLT_USINFO",
                  finalObj ? JSON.stringify(finalObj) : {}
                );

                window.localStorage.setItem("JWT_TOKEN", data.data.token);

                window.localStorage.setItem("USER_ROLE_NAME", checkAccess);

                this.sendAuditLogs({
                  cinema_id: finalObj.cinema_id,
                  user_id: finalObj.user_id,
                  action: `Kitchen User Logged In - (${checkAccess})`,
                  page_name: "Kitchen Display",
                  api_name: window.location.hash
                });

                if (data.data.user.order_pickup_access_only == "Y") {
                  console.log("route to kitchen-pickup");
                  this.$router.push({
                    path: "/kitchen-pickup"
                  });
                } else {
                  console.log("route to kitchen-sales");
                  this.$router.push({
                    path: "/kitchen-sales"
                  });
                }
              } else {
                this.$toasted.show(
                  "Sorry You Are Not A Pos Operator Or Your Shift is Not Created"
                );
              }
              /**
               * START SHIFT
               */
            } else {
              this.$toasted.show(
                data.message ||
                  "Sorry! Something went wrong. kindly contact your administrator"
              );
            }
          })
          .catch(error => {
            this.hideLoginViaPin();
            this.$toasted.show(error);
          })
          .finally(() => {
            setTimeout(() => {
              this.hideLoading();
            }, 1000);
          });
      }
    },
    checkPosAccess(user) {
      let status = "";
      if ([4, 8].includes(user.role_id)) {
        if (user.pos_access == "Y" && user.fnb_access == "Y") {
          status = "SUPER";
        } else if (user.pos_access == "Y" && user.fnb_access == "N") {
          status = "POSONLY";
        } else if (user.pos_access == "N" && user.fnb_access == "Y") {
          status = "FNBONLY";
        }
      } else if ([13].includes(user.role_id)) {
        if (user.order_pickup_access_only == "Y") {
          status = "PICKUPKITCHEN";
        } else {
          status = "KITCHENUSER";
        }
      }
      return status;
    },
    initTimMachine() {
      let configObj = {
        pos_id: "",
        ecr_user_id: null,
        ecr_ip_address: "",
        ecr_port: ""
      };
      if (
        !localStorage.getItem("ECR_INIT_STATUS") &&
        this.$cookie.get("ECR_INFO")
      ) {
        let ECR_INFO = JSON.parse(this.$cookie.get("ECR_INFO"));
        Object.keys(ECR_INFO).map(x => {
          configObj[x] = ECR_INFO[x];
        });

        if (configObj.ecr_ip_address && configObj.ecr_port) {
          setTimeout(z => {
            let obj = {
              EventBus: EventBus,
              IPADDRESS: configObj.ecr_ip_address,
              PORT: configObj.ecr_port,
              USERID: configObj.ecr_user_id,
              POSID: configObj.pos_id,
              INTEGRATIONID: "367fcd48-f574-4119-960c-d1ebb00f9a97"
            };
            if (typeof initTimApi == "function") {
              initTimApi(obj);
              localStorage.setItem("ECR_INIT_STATUS", true);
            }
          }, 500);
        } else {
          localStorage.setItem("ECR_INIT_STATUS", false);
        }
      } else {
        console.log("ECR Settings not found");
      }
    },
    openNotificaton: function() {},
    /* eslint-disable */
    changeLanguage: function({ language, title }) {},
    togglePassword() {
      if (this.passwordType == "password") {
        this.passwordType = "text";
      } else {
        this.passwordType = "password";
      }
    }
  }
};
</script>

<style scoped>
.nuvio-login-page {
  min-height: 100vh;
  position: relative;
  overflow: hidden;
  color: #f8fafc;
  background: radial-gradient(circle at top left, #1d4ed8 0, transparent 28%),
    radial-gradient(circle at bottom right, #f97316 0, transparent 24%),
    linear-gradient(135deg, #050816 0%, #111827 48%, #0f172a 100%);
}

.nuvio-orb {
  position: absolute;
  border-radius: 50%;
  filter: blur(2px);
  opacity: 0.38;
  pointer-events: none;
}

.nuvio-orb-one {
  width: 360px;
  height: 360px;
  top: -120px;
  right: 12%;
  background: rgba(59, 130, 246, 0.8);
}

.nuvio-orb-two {
  width: 300px;
  height: 300px;
  left: -90px;
  bottom: -120px;
  background: rgba(249, 115, 22, 0.72);
}

.nuvio-login-shell {
  min-height: 100vh;
  position: relative;
  z-index: 1;
  padding: 28px;
  display: flex;
  flex-direction: column;
}

.nuvio-login-header {
  flex: 0 0 auto;
  padding: 16px 20px;
  border: 1px solid rgba(255, 255, 255, 0.12);
  border-radius: 28px;
  background: rgba(15, 23, 42, 0.74);
  box-shadow: 0 24px 70px rgba(0, 0, 0, 0.22);
}

.nuvio-brand-mark {
  width: 48px;
  height: 48px;
  margin-right: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 16px;
  color: #0f172a;
  font-size: 26px;
  font-weight: 900;
  background: linear-gradient(135deg, #ffffff, #93c5fd);
  box-shadow: 0 16px 32px rgba(59, 130, 246, 0.32);
}

.nuvio-brand-name {
  font-size: 28px;
  line-height: 1;
  font-weight: 900;
  letter-spacing: -0.04em;
}

.nuvio-brand-subtitle {
  margin-top: 5px;
  color: #bfdbfe;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.12em;
  text-transform: uppercase;
}

.nuvio-env-badge {
  padding: 9px 14px;
  border-radius: 999px;
  color: #dbeafe;
  font-size: 12px;
  font-weight: 800;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  background: rgba(37, 99, 235, 0.22);
  border: 1px solid rgba(147, 197, 253, 0.28);
}

.nuvio-org-logo {
  max-width: 170px;
  min-width: 100px;
  height: 54px;
  padding: 8px 12px;
  border-radius: 16px;
  background: rgba(255, 255, 255, 0.92);
  display: flex;
  align-items: center;
  justify-content: center;
}

.nuvio-org-logo img {
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
}

.nuvio-login-main {
  flex: 1 1 auto;
  margin-top: 24px;
  min-height: 0;
}

.nuvio-hero-panel,
.nuvio-auth-panel {
  display: flex;
}

.nuvio-hero-card {
  width: 100%;
  padding: 48px;
  border-radius: 34px 0 0 34px;
  background: linear-gradient(
    145deg,
    rgba(15, 23, 42, 0.9),
    rgba(30, 41, 59, 0.64)
  );
  border: 1px solid rgba(255, 255, 255, 0.12);
  border-right: 0;
  box-shadow: 0 30px 100px rgba(0, 0, 0, 0.28);
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.nuvio-terminal-chip {
  width: fit-content;
  padding: 10px 14px;
  border-radius: 999px;
  color: #bbf7d0;
  font-size: 12px;
  font-weight: 800;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  background: rgba(22, 163, 74, 0.14);
  border: 1px solid rgba(134, 239, 172, 0.28);
}

.nuvio-live-dot {
  width: 8px;
  height: 8px;
  display: inline-block;
  margin-right: 8px;
  border-radius: 50%;
  background: #22c55e;
  box-shadow: 0 0 0 6px rgba(34, 197, 94, 0.14);
}

.nuvio-hero-card h1 {
  max-width: 720px;
  margin: 28px 0 18px;
  font-size: 58px;
  line-height: 1;
  font-weight: 900;
  letter-spacing: -0.06em;
}

.nuvio-hero-card p {
  max-width: 660px;
  color: #cbd5e1;
  font-size: 18px;
  line-height: 1.65;
}

.nuvio-feature-grid {
  margin-top: 34px;
}

.nuvio-feature-card {
  min-height: 152px;
  padding: 22px;
  border-radius: 24px;
  background: rgba(255, 255, 255, 0.08);
  border: 1px solid rgba(255, 255, 255, 0.11);
}

.nuvio-feature-icon {
  width: 42px;
  height: 42px;
  margin-bottom: 18px;
  border-radius: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #0f172a;
  font-size: 13px;
  font-weight: 900;
  background: #f8fafc;
}

.nuvio-feature-card h5 {
  margin-bottom: 8px;
  color: #ffffff;
  font-size: 16px;
  font-weight: 800;
}

.nuvio-feature-card span {
  color: #cbd5e1;
  font-size: 13px;
  line-height: 1.5;
}

.nuvio-counter-preview {
  margin-top: 22px;
  padding: 18px;
  border-radius: 24px;
  display: flex;
  justify-content: space-between;
  background: rgba(15, 23, 42, 0.72);
  border: 1px solid rgba(148, 163, 184, 0.22);
}

.nuvio-counter-preview div {
  display: flex;
  flex-direction: column;
}

.nuvio-counter-preview span {
  color: #94a3b8;
  font-size: 11px;
  font-weight: 800;
  letter-spacing: 0.1em;
  text-transform: uppercase;
}

.nuvio-counter-preview strong {
  margin-top: 6px;
  color: #ffffff;
  font-size: 15px;
}

.nuvio-auth-panel {
  align-items: stretch;
}

.nuvio-auth-card {
  width: 100%;
  padding: 38px;
  border-radius: 0 34px 34px 0;
  color: #0f172a;
  background: rgba(255, 255, 255, 0.97);
  box-shadow: 0 30px 100px rgba(0, 0, 0, 0.3);
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.nuvio-kicker {
  color: #2563eb;
  font-size: 12px;
  font-weight: 900;
  letter-spacing: 0.12em;
  text-transform: uppercase;
}

.nuvio-auth-heading h2 {
  margin: 12px 0 8px;
  color: #0f172a;
  font-size: 32px;
  line-height: 1.1;
  font-weight: 900;
  letter-spacing: -0.04em;
}

.nuvio-auth-heading p {
  margin-bottom: 24px;
  color: #64748b;
  font-size: 15px;
  line-height: 1.5;
}

.nuvio-auth-switch {
  padding: 5px;
  border-radius: 18px;
  background: #eef2ff;
}

.nuvio-switch-btn {
  flex: 1;
  height: 50px;
  border: 0;
  border-radius: 14px;
  color: #475569;
  font-size: 14px;
  font-weight: 900;
  background: transparent;
  cursor: pointer;
  transition: all 0.2s ease;
}

.nuvio-switch-btn.active {
  color: #ffffff;
  background: linear-gradient(135deg, #2563eb, #1d4ed8);
  box-shadow: 0 12px 24px rgba(37, 99, 235, 0.28);
}

.nuvio-field-label {
  margin-bottom: 9px;
  color: #334155;
  font-size: 12px;
  font-weight: 900;
  letter-spacing: 0.08em;
  text-transform: uppercase;
}

.nuvio-pin-input,
.nuvio-input-shell input {
  width: 100%;
  height: 58px;
  border: 1px solid #dbe4f0;
  border-radius: 18px;
  color: #0f172a;
  font-size: 16px;
  font-weight: 800;
  background: #f8fafc;
  outline: none;
  transition: all 0.2s ease;
}

.nuvio-pin-input {
  padding: 0 18px;
  text-align: center;
}

.nuvio-pin-input:focus,
.nuvio-pin-input.active,
.nuvio-input-shell input:focus {
  border-color: #2563eb;
  background: #ffffff;
  box-shadow: 0 0 0 4px rgba(37, 99, 235, 0.12);
}

.nuvio-pin-pad {
  margin-top: 24px;
}

.nuvio-key {
  width: 100%;
  height: 68px;
  border: 1px solid #e2e8f0;
  /*border-radius: 22px;*/
  border-radius: 10px;
  color: #0f172a;
  font-size: 24px;
  font-weight: 900;
  background: #ffffff;
  box-shadow: 0 12px 24px rgba(15, 23, 42, 0.06);
  cursor: pointer;
  transition: all 0.15s ease;
}

.nuvio-key:hover,
.nuvio-key:focus {
  border-color: #bfdbfe;
  color: #1d4ed8;
  transform: translateY(-1px);
}

.nuvio-key:active {
  transform: translateY(1px) scale(0.99);
}

.nuvio-key-muted {
  color: #64748b;
  background: #f1f5f9;
}

.nuvio-primary-btn {
  height: 58px;
  border: 0;
  border-radius: 18px;
  color: #ffffff;
  font-size: 15px;
  font-weight: 900;
  letter-spacing: 0.02em;
  background: linear-gradient(135deg, #f97316, #ea580c);
  box-shadow: 0 18px 34px rgba(249, 115, 22, 0.28);
  cursor: pointer;
  transition: all 0.2s ease;
}

.nuvio-primary-btn:hover,
.nuvio-primary-btn:focus {
  transform: translateY(-1px);
  box-shadow: 0 22px 40px rgba(249, 115, 22, 0.36);
}

.nuvio-input-group {
  position: relative;
}

.nuvio-input-shell {
  position: relative;
}

.nuvio-input-shell .login-icon {
  width: 20px;
  height: 20px;
  position: absolute;
  top: 50%;
  left: 18px;
  z-index: 2;
  transform: translateY(-50%);
  opacity: 0.65;
}

.nuvio-input-shell input {
  padding: 0 52px;
}

.show-password-icon,
.hide-password-icon {
  position: absolute;
  top: 50%;
  right: 18px;
  z-index: 3;
  cursor: pointer;
  transform: translateY(-50%);
}

.nuvio-input-shell input::placeholder,
.nuvio-pin-input::placeholder {
  color: #94a3b8;
  font-weight: 700;
}

.nuvio-login-footer {
  flex: 0 0 auto;
  padding: 16px 6px 0;
  color: #cbd5e1;
  font-size: 13px;
  font-weight: 700;
  display: flex;
  justify-content: space-between;
}

.textPin:not(:placeholder-shown) {
  font-size: 19px;
  letter-spacing: 9px;
}

@media (max-width: 1199px) {
  .nuvio-hero-card h1 {
    font-size: 46px;
  }

  .nuvio-auth-card,
  .nuvio-hero-card {
    padding: 32px;
  }
}

@media (max-width: 991px) {
  .nuvio-login-shell {
    padding: 18px;
  }

  .nuvio-hero-card {
    border-radius: 30px 30px 0 0;
    border-right: 1px solid rgba(255, 255, 255, 0.12);
    min-height: auto;
  }

  .nuvio-auth-card {
    border-radius: 0 0 30px 30px;
  }
}

@media (max-width: 767px) {
  .nuvio-login-header,
  .nuvio-counter-preview,
  .nuvio-login-footer {
    flex-direction: column;
    align-items: flex-start !important;
  }

  .nuvio-org-logo {
    margin-top: 14px;
  }

  .nuvio-hero-card h1 {
    font-size: 34px;
  }

  .nuvio-hero-card p {
    font-size: 15px;
  }

  .nuvio-counter-preview div + div {
    margin-top: 14px;
  }

  .nuvio-login-footer span + span {
    margin-top: 8px;
  }
}

.nuvio-login-page {
  min-height: 100vh;
  color: #1f2937;
  background: #f4f6f8;
}

.nuvio-login-shell {
  min-height: 100vh;
  max-width: 1060px;
  margin: 0 auto;
  padding: 24px;
  display: flex;
  flex-direction: column;
}

.nuvio-login-header {
  padding: 0;
  border: 0;
  border-radius: 0;
  background: transparent;
  box-shadow: none;
}

.nuvio-brand-mark {
  width: 38px;
  height: 38px;
  margin-right: 10px;
  border-radius: 12px;
  color: #ffffff;
  font-size: 20px;
  font-weight: 800;
  background: #2563eb;
  box-shadow: none;
}

.nuvio-brand-name {
  color: #111827;
  font-size: 21px;
  font-weight: 800;
  letter-spacing: -0.03em;
}

.nuvio-brand-subtitle {
  margin-top: 1px;
  color: #6b7280;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.06em;
}

.nuvio-env-badge {
  padding: 6px 10px;
  color: #475569;
  font-size: 11px;
  background: #eef2f7;
  border: 1px solid #e5e7eb;
}

.nuvio-org-logo {
  max-width: 170px;
  min-width: 100px;
  height: 42px;
  padding: 6px 10px;
  border: 1px solid #e5e7eb;
  border-radius: 12px;
  background: #ffffff;
}

.nuvio-login-main {
  flex: 1;
  margin-top: 22px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.nuvio-app-window {
  width: 100%;
  max-width: 880px;
  overflow: hidden;
  border: 1px solid #dfe4ea;
  border-radius: 22px;
  background: #ffffff;
  box-shadow: 0 24px 70px rgba(15, 23, 42, 0.12);
}

.nuvio-window-bar {
  height: 46px;
  padding: 0 18px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  color: #6b7280;
  font-size: 13px;
  font-weight: 700;
  background: #fbfcfd;
  border-bottom: 1px solid #edf0f3;
}

.nuvio-window-dots {
  position: absolute;
  left: 18px;
  display: flex;
  align-items: center;
}

.nuvio-window-dots span {
  width: 10px;
  height: 10px;
  margin-right: 7px;
  display: block;
  border-radius: 50%;
  background: #d1d5db;
}

.nuvio-window-body {
  display: flex;
  min-height: 560px;
}

.nuvio-side-pane {
  width: 300px;
  padding: 36px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  background: linear-gradient(180deg, #f8fafc 0%, #eef4ff 100%);
  border-right: 1px solid #edf0f3;
}

.nuvio-side-logo {
  width: 58px;
  height: 58px;
  margin-bottom: 22px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 18px;
  color: #ffffff;
  font-size: 28px;
  font-weight: 900;
  background: #2563eb;
}

.nuvio-side-pane h1 {
  margin: 0;
  color: #111827;
  font-size: 34px;
  line-height: 1;
  font-weight: 900;
  letter-spacing: -0.05em;
}

.nuvio-side-pane p {
  margin: 10px 0 0;
  color: #64748b;
  font-size: 15px;
  font-weight: 700;
}

.nuvio-auth-card {
  width: auto;
  flex: 1;
  padding: 42px;
  border-radius: 0;
  color: #111827;
  background: #ffffff;
  box-shadow: none;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.nuvio-auth-heading h2 {
  margin: 0 0 6px;
  color: #111827;
  font-size: 25px;
  line-height: 1.2;
  font-weight: 850;
  letter-spacing: -0.03em;
}

.nuvio-auth-heading p {
  margin-bottom: 22px;
  color: #6b7280;
  font-size: 14px;
}

.nuvio-auth-switch {
  padding: 4px;
  border: 1px solid #e5e7eb;
  border-radius: 12px;
  background: #f8fafc;
}

.nuvio-switch-btn {
  height: 40px;
  border-radius: 9px;
  color: #6b7280;
  font-size: 13px;
  font-weight: 800;
}

.nuvio-switch-btn.active {
  color: #111827;
  background: #ffffff;
  box-shadow: 0 4px 14px rgba(15, 23, 42, 0.08);
}

.nuvio-field-label {
  margin-bottom: 7px;
  color: #6b7280;
  font-size: 11px;
  font-weight: 800;
  letter-spacing: 0.05em;
}

.nuvio-pin-input,
.nuvio-input-shell input {
  height: 48px;
  border: 1px solid #dbe1e8;
  border-radius: 12px;
  color: #111827;
  font-size: 15px;
  font-weight: 700;
  background: #ffffff;
}

.nuvio-pin-input:focus,
.nuvio-pin-input.active,
.nuvio-input-shell input:focus {
  border-color: #2563eb;
  box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.1);
}

.nuvio-pin-pad {
  margin-top: 18px;
}

.nuvio-key {
  height: 52px;
  border: 1px solid #e5e7eb;
  border-radius: 12px;
  color: #111827;
  font-size: 19px;
  font-weight: 800;
  background: #fdfdfd;
  box-shadow: none;
}

.nuvio-key:hover,
.nuvio-key:focus {
  border-color: #c7d2fe;
  color: #1d4ed8;
  transform: none;
  background: #f8fafc;
}

.nuvio-key-muted {
  color: #6b7280;
  background: #f7f8fa;
}

.nuvio-primary-btn {
  height: 48px;
  border-radius: 12px;
  font-size: 14px;
  font-weight: 850;
  background: #2563eb;
  box-shadow: none;
}

.nuvio-primary-btn:hover,
.nuvio-primary-btn:focus {
  transform: none;
  background: #1d4ed8;
  box-shadow: none;
}

.nuvio-input-shell .login-icon {
  width: 18px;
  height: 18px;
  left: 15px;
}

.nuvio-input-shell input {
  padding: 0 44px;
}

.show-password-icon,
.hide-password-icon {
  right: 15px;
}

.nuvio-login-footer {
  padding: 14px 2px 0;
  color: #9ca3af;
  font-size: 12px;
}

.textPin:not(:placeholder-shown) {
  font-size: 17px;
  letter-spacing: 7px;
}

@media (max-width: 767px) {
  .nuvio-login-shell {
    padding: 16px;
  }

  .nuvio-window-body {
    min-height: auto;
    display: block;
  }

  .nuvio-side-pane {
    width: 100%;
    padding: 24px;
    border-right: 0;
    border-bottom: 1px solid #edf0f3;
  }

  .nuvio-auth-card {
    padding: 28px 24px;
  }
}

.nuvio-login-page {
  min-height: 100vh;
  color: #111827;
  background: radial-gradient(
      circle at 18% 12%,
      rgba(37, 99, 235, 0.08),
      transparent 28%
    ),
    radial-gradient(circle at 82% 82%, rgba(15, 23, 42, 0.06), transparent 32%),
    #f5f7fb;
}

.nuvio-login-shell {
  width: 100%;
  min-height: 100vh;
  max-width: 1180px;
  margin: 0 auto;
  padding: 26px 30px;
  display: flex;
  flex-direction: column;
}

.nuvio-login-header {
  padding: 0;
  border: 0;
  border-radius: 0;
  color: #111827;
  background: transparent;
  box-shadow: none;
}

.nuvio-brand-mark {
  width: 40px;
  height: 40px;
  margin-right: 12px;
  border-radius: 12px;
  color: #ffffff;
  font-size: 20px;
  font-weight: 900;
  background: linear-gradient(135deg, #111827, #2563eb);
  box-shadow: 0 10px 22px rgba(37, 99, 235, 0.22);
}

.nuvio-brand-name {
  color: #111827;
  font-size: 22px;
  line-height: 1;
  font-weight: 900;
  letter-spacing: -0.04em;
}

.nuvio-brand-subtitle {
  margin-top: 5px;
  color: #6b7280;
  font-size: 11px;
  font-weight: 800;
  letter-spacing: 0.1em;
}

.nuvio-env-badge {
  padding: 7px 11px;
  border-radius: 999px;
  color: #475569;
  font-size: 11px;
  font-weight: 800;
  letter-spacing: 0.08em;
  background: rgba(255, 255, 255, 0.72);
  border: 1px solid #e5e7eb;
}

.nuvio-org-logo {
  width: 140px;
  height: 45px;
  padding: 7px 12px;
  border: 1px solid #e5e7eb;
  border-radius: 14px;
  background: rgba(255, 255, 255, 0.86);
  box-shadow: 0 10px 24px rgba(15, 23, 42, 0.04);
}

.nuvio-org-logo img {
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
}

.nuvio-login-main {
  flex: 1;
  margin-top: 28px;
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 0;
}

.nuvio-terminal-card {
  width: 100%;
  max-width: 920px;
  min-height: 590px;
  display: grid;
  grid-template-columns: 330px minmax(0, 1fr);
  overflow: hidden;
  border: 1px solid rgba(203, 213, 225, 0.9);
  border-radius: 28px;
  background: rgba(255, 255, 255, 0.94);
  box-shadow: 0 28px 70px rgba(15, 23, 42, 0.13);
}

.nuvio-rail-status {
  padding: 16px;
  border: 1px solid rgba(203, 213, 225, 0.8);
  border-radius: 20px;
  background: rgba(255, 255, 255, 0.76);
}

.nuvio-rail-status div {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.nuvio-rail-status div + div {
  margin-top: 13px;
  padding-top: 13px;
  border-top: 1px solid #e5e7eb;
}

.nuvio-rail-status span {
  color: #94a3b8;
  font-size: 11px;
  font-weight: 900;
  letter-spacing: 0.1em;
  text-transform: uppercase;
}

.nuvio-rail-status strong {
  color: #0f172a;
  font-size: 13px;
  font-weight: 850;
}

.nuvio-auth-card {
  width: 100%;
  padding: 44px 52px;
  border-radius: 0;
  color: #111827;
  background: #ffffff;
  box-shadow: none;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.nuvio-auth-heading {
  margin-bottom: 24px;
}

.nuvio-status-pill {
  width: fit-content;
  margin-bottom: 16px;
  padding: 7px 11px;
  display: flex;
  align-items: center;
  border-radius: 999px;
  color: #166534;
  font-size: 11px;
  font-weight: 900;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  background: #f0fdf4;
  border: 1px solid #bbf7d0;
}

.nuvio-status-pill span {
  width: 7px;
  height: 7px;
  margin-right: 8px;
  border-radius: 50%;
  background: #22c55e;
}

.nuvio-auth-heading h2 {
  margin: 0;
  color: #111827;
  font-size: 30px;
  line-height: 1.15;
  font-weight: 900;
  letter-spacing: -0.045em;
}

.nuvio-auth-heading p {
  margin: 9px 0 0;
  color: #64748b;
  font-size: 14px;
  line-height: 1.5;
  font-weight: 600;
}

.nuvio-auth-switch {
  margin-bottom: 24px;
  padding: 4px;
  border: 1px solid #e5e7eb;
  border-radius: 14px;
  background: #f8fafc;
}

.nuvio-switch-btn {
  flex: 1;
  height: 42px;
  border: 0;
  border-radius: 10px;
  color: #64748b;
  font-size: 13px;
  font-weight: 850;
  background: transparent;
  cursor: pointer;
  transition: color 0.18s ease, background 0.18s ease, box-shadow 0.18s ease;
}

.nuvio-switch-btn.active {
  color: #0f172a;
  background: #ffffff;
  box-shadow: 0 8px 20px rgba(15, 23, 42, 0.08);
}

.nuvio-pin-fields {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 14px;
}

.nuvio-field-label {
  display: block;
  margin-bottom: 8px;
  color: #475569;
  font-size: 11px;
  font-weight: 900;
  letter-spacing: 0.08em;
  text-transform: uppercase;
}

.nuvio-pin-input,
.nuvio-input-shell input {
  width: 100%;
  height: 52px;
  border: 1px solid #d8dee8;
  border-radius: 14px;
  color: #111827;
  font-size: 15px;
  font-weight: 750;
  background: #ffffff;
  outline: none;
  transition: border-color 0.18s ease, box-shadow 0.18s ease,
    background 0.18s ease;
}

.nuvio-pin-input {
  padding: 0 16px;
  text-align: center;
}

.nuvio-pin-input:focus,
.nuvio-pin-input.active,
.nuvio-input-shell input:focus {
  border-color: #2563eb;
  background: #ffffff;
  box-shadow: 0 0 0 4px rgba(37, 99, 235, 0.1);
}

.nuvio-pin-pad {
  margin-top: 20px;
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 10px;
}

.nuvio-key {
  height: 56px;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  color: #0f172a;
  font-size: 20px;
  font-weight: 850;
  background: linear-gradient(180deg, #ffffff, #f8fafc);
  box-shadow: inset 0 -1px 0 rgba(15, 23, 42, 0.04);
  cursor: pointer;
  transition: border-color 0.16s ease, color 0.16s ease, transform 0.16s ease,
    background 0.16s ease;
}

.nuvio-key:hover,
.nuvio-key:focus {
  border-color: #bfdbfe;
  color: #1d4ed8;
  background: #ffffff;
  transform: translateY(-1px);
}

.nuvio-key:active {
  transform: translateY(0);
}

.nuvio-key-muted {
  color: #64748b;
  background: #f3f6fa;
}

.nuvio-primary-btn {
  height: 52px;
  margin-top: 16px;
  border: 0;
  border-radius: 14px;
  color: #ffffff;
  font-size: 14px;
  font-weight: 900;
  letter-spacing: 0.01em;
  background: linear-gradient(135deg, #1d4ed8, #2563eb);
  box-shadow: 0 14px 26px rgba(37, 99, 235, 0.22);
  cursor: pointer;
  transition: transform 0.18s ease, box-shadow 0.18s ease, background 0.18s ease;
}

.nuvio-primary-btn:hover,
.nuvio-primary-btn:focus {
  background: linear-gradient(135deg, #1e40af, #2563eb);
  box-shadow: 0 18px 34px rgba(37, 99, 235, 0.28);
  transform: translateY(-1px);
}

.nuvio-credential-form {
  display: grid;
  gap: 16px;
}

.nuvio-input-group {
  position: relative;
}

.nuvio-input-shell {
  position: relative;
}

.nuvio-input-shell .login-icon {
  width: 18px;
  height: 18px;
  position: absolute;
  top: 50%;
  left: 16px;
  z-index: 2;
  opacity: 0.52;
  transform: translateY(-50%);
}

.nuvio-input-shell input {
  padding: 0 48px;
}

.show-password-icon,
.hide-password-icon {
  position: absolute;
  top: 50%;
  right: 16px;
  z-index: 3;
  cursor: pointer;
  opacity: 0.68;
  transform: translateY(-50%);
}

.nuvio-input-shell input::placeholder,
.nuvio-pin-input::placeholder {
  color: #a0aec0;
  font-weight: 650;
}

.nuvio-login-footer {
  flex: 0 0 auto;
  padding: 18px 2px 0;
  color: #94a3b8;
  font-size: 12px;
  font-weight: 750;
  display: flex;
  justify-content: space-between;
}

.textPin:not(:placeholder-shown) {
  font-size: 18px;
  letter-spacing: 8px;
}

@media (max-width: 991px) {
  .nuvio-terminal-card {
    max-width: 620px;
    grid-template-columns: 1fr;
  }

  .nuvio-terminal-rail {
    padding: 28px 32px;
    border-right: 0;
    border-bottom: 1px solid #e5e7eb;
  }

  .nuvio-rail-status {
    margin-top: 24px;
  }
}

@media (max-width: 767px) {
  .nuvio-login-shell {
    padding: 18px;
  }

  .nuvio-login-header {
    align-items: flex-start !important;
  }

  .nuvio-login-header > .d-flex:last-child {
    margin-top: 14px;
  }

  .nuvio-terminal-card {
    min-height: auto;
    border-radius: 22px;
  }

  .nuvio-terminal-rail,
  .nuvio-auth-card {
    padding: 26px 22px;
  }

  .nuvio-pin-fields {
    grid-template-columns: 1fr;
  }

  .nuvio-login-footer {
    display: block;
  }

  .nuvio-login-footer span {
    display: block;
  }

  .nuvio-login-footer span + span {
    margin-top: 6px;
  }
}
.nuvio-login-page {
  min-height: 100vh;
  color: #20242b;
  font-family: Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif;
  background: #eef1f5;
}

.nuvio-login-shell {
  width: 100%;
  min-height: 100vh;
  max-width: 1080px;
  margin: 0 auto;
  padding: 22px 28px;
  display: flex;
  flex-direction: column;
}

.nuvio-login-header {
  height: 48px;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border: 0;
  border-radius: 0;
  background: transparent;
  box-shadow: none;
}

.nuvio-header-brand,
.nuvio-header-client {
  display: flex;
  align-items: center;
}

.nuvio-header-client {
  justify-content: flex-end;
  gap: 10px;
}

.nuvio-brand-mark {
  width: 34px;
  height: 34px;
  margin-right: 10px;
  border-radius: 10px;
  color: #ffffff;
  font-size: 17px;
  font-weight: 800;
  background: #1f2937;
  box-shadow: none;
}

.nuvio-brand-name {
  color: #1f2937;
  font-size: 19px;
  line-height: 1;
  font-weight: 800;
  letter-spacing: -0.03em;
}

.nuvio-brand-subtitle {
  margin-top: 4px;
  color: #7b8492;
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.04em;
  text-transform: lowercase;
}

.nuvio-env-badge {
  padding: 5px 9px;
  border: 1px solid #d9dee7;
  border-radius: 999px;
  color: #626b78;
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 0.06em;
  background: rgba(255, 255, 255, 0.74);
}

.nuvio-org-logo,
.nuvio-org-fallback {
  width: 140px;
  height: 45px;
  padding: 6px 10px;
  border: 1px solid #d9dee7;
  border-radius: 12px;
  background: rgba(255, 255, 255, 0.82);
  display: flex;
  align-items: center;
  justify-content: center;
}

.nuvio-org-logo img {
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
}

.nuvio-org-fallback {
  color: #4b5563;
  font-size: 12px;
  font-weight: 700;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.nuvio-login-main {
  flex: 1;
  margin: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 0;
}

.nuvio-login-card {
  width: 100%;
  max-width: 860px;
  min-height: 520px;
  display: grid;
  grid-template-columns: 1fr 1fr;
  overflow: hidden;
  border: 1px solid rgba(210, 216, 226, 0.95);
  border-radius: 26px;
  background: rgba(255, 255, 255, 0.88);
  box-shadow: 0 22px 55px rgba(31, 41, 55, 0.12);
}

.nuvio-brand-panel {
  position: relative;
  min-width: 0;
  padding: 44px;
  display: flex;
  align-items: center;
  background: #66508e;
  border-right: 1px solid #e3e8f0;
}

.nuvio-brand-copy {
  position: relative;
  z-index: 1;
}

.nuvio-panel-mark {
  width: 48px;
  height: 48px;
  margin-bottom: 18px;
  border-radius: 14px;
  color: #ffffff;
  font-size: 24px;
  font-weight: 850;
  background: #1f2937;
  display: flex;
  align-items: center;
  justify-content: center;
}

.nuvio-brand-panel h1 {
  margin: 0;
  color: #1f2937;
  font-size: 42px;
  line-height: 1;
  font-weight: 850;
  letter-spacing: -0.06em;
}

.nuvio-brand-panel p {
  margin: 12px 0 0;
  color: #6b7280;
  font-size: 14px;
  font-weight: 600;
  letter-spacing: 0.06em;
  text-transform: lowercase;
}

.nuvio-movie-watermark {
  position: absolute;
  right: 24px;
  bottom: 22px;
  width: 210px;
  height: 210px;
  fill: none;
  stroke: #1f2937;
  stroke-width: 5;
  stroke-linecap: round;
  stroke-linejoin: round;
  opacity: 0.055;
}

.nuvio-auth-panel {
  padding: 20px 48px;
  background: rgba(255, 255, 255, 0.96);
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.nuvio-auth-heading {
  margin-bottom: 18px;
}

.nuvio-auth-heading span {
  color: #8a94a3;
  font-size: 11px;
  font-weight: 800;
  letter-spacing: 0.1em;
  text-transform: uppercase;
}

.nuvio-auth-heading h2 {
  margin: 6px 0 0;
  color: #1f2937;
  font-size: 26px;
  line-height: 1.15;
  font-weight: 800;
  letter-spacing: -0.035em;
}

.nuvio-auth-switch {
  width: 100%;
  height: 36px;
  margin: 0 0 18px;
  padding: 3px;
  border: 1px solid #dfe4ec;
  border-radius: 999px;
  background: #f5f7fa;
  display: flex;
}

.nuvio-switch-btn {
  flex: 1;
  height: 28px;
  border: 0;
  border-radius: 999px;
  color: #737d8c;
  font-size: 12px;
  font-weight: 700;
  background: transparent;
  cursor: pointer;
  transition: background 0.16s ease, color 0.16s ease, box-shadow 0.16s ease;
}

.nuvio-switch-btn.active {
  color: #ffffff;
  background: var(--blue);
  box-shadow: 0 4px 10px rgba(31, 41, 55, 0.16);
}

.nuvio-pin-form,
.nuvio-credential-form {
  margin: 0;
}

.nuvio-pin-fields {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
}

.nuvio-field-label {
  display: block;
  margin-bottom: 6px;
  color: #596273;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.03em;
  text-transform: none;
}

.nuvio-pin-input,
.nuvio-input-shell input {
  width: 100%;
  height: 40px;
  border: 1px solid #d8dee8;
  border-radius: 11px;
  color: #242a33;
  font-size: 13px;
  font-weight: 600;
  background: #ffffff;
  outline: none;
  transition: border-color 0.16s ease, box-shadow 0.16s ease;
}

.nuvio-pin-input {
  padding: 0 12px;
  text-align: center;
}

.nuvio-pin-input:focus,
.nuvio-pin-input.active,
.nuvio-input-shell input:focus {
  border-color: #aeb7c5;
  box-shadow: 0 0 0 3px rgba(31, 41, 55, 0.07);
}

.nuvio-pin-pad {
  margin-top: 14px;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 8px;
}

.nuvio-key {
  height: 40px;
  border: 1px solid #dfe4ec;
  border-radius: 11px;
  color: #2b313b;
  font-size: 14px;
  font-weight: 700;
  background: #ffffff;
  box-shadow: none;
  cursor: pointer;
  transition: border-color 0.14s ease, background 0.14s ease;
}

.nuvio-key:hover,
.nuvio-key:focus {
  border-color: #b8c7dd;
  color: #1f2937;
  background: #f8fafc;
  transform: none;
}

.nuvio-key:active {
  transform: none;
}

.nuvio-key-muted {
  color: #7b8492;
  background: #f7f9fb;
}

.nuvio-primary-btn {
  height: 40px;
  margin-top: 14px;
  border: 0;
  border-radius: 11px;
  color: #ffffff;
  font-size: 13px;
  font-weight: 750;
  letter-spacing: 0;
  background: var(--blue);
  box-shadow: none;
  cursor: pointer;
  transition: background 0.16s ease;
}

.nuvio-primary-btn:hover,
.nuvio-primary-btn:focus {
  background: #1f2937;
  box-shadow: none;
  transform: none;
}

.nuvio-credential-form {
  display: grid;
  gap: 12px;
}

.nuvio-input-group {
  position: relative;
}

.nuvio-input-shell {
  position: relative;
}

.nuvio-input-shell .login-icon {
  width: 15px;
  height: 15px;
  position: absolute;
  top: 50%;
  left: 13px;
  z-index: 2;
  opacity: 0.5;
  transform: translateY(-50%);
}

.nuvio-input-shell input {
  padding: 0 40px;
}

.show-password-icon,
.hide-password-icon {
  position: absolute;
  top: 50%;
  right: 13px;
  z-index: 3;
  width: 15px;
  height: 15px;
  cursor: pointer;
  opacity: 0.58;
  transform: translateY(-50%);
}

.nuvio-input-shell input::placeholder,
.nuvio-pin-input::placeholder {
  color: #a2acba;
  font-weight: 500;
}

.textPin:not(:placeholder-shown) {
  font-size: 14px;
  letter-spacing: 6px;
}

@media (max-width: 900px) {
  .nuvio-login-card {
    max-width: 560px;
    grid-template-columns: 1fr;
  }

  .nuvio-brand-panel {
    min-height: 190px;
    padding: 30px;
    border-right: 0;
    border-bottom: 1px solid #e3e8f0;
  }

  .nuvio-auth-panel {
    /*padding: 30px;*/
  }
}

@media (max-width: 640px) {
  .nuvio-login-shell {
    padding: 16px;
  }

  .nuvio-login-header {
    height: auto;
    align-items: flex-start;
    gap: 12px;
  }

  .nuvio-header-client {
    flex-shrink: 0;
  }

  .nuvio-login-main {
    margin-top: 18px;
    align-items: flex-start;
  }

  .nuvio-pin-fields {
    grid-template-columns: 1fr;
  }
}

.nuvio-login-shell {
  max-width: 100%;
  padding: 22px 28px;
}

.nuvio-login-main {
  padding: 14px 0 10px;
}

.nuvio-header-brand {
  min-width: 0;
}

.nuvio-brand-logo {
  width: 112px;
  height: auto;
  display: block;
  margin-right: 14px;
}

.nuvio-brand-subtitle {
  margin-top: 0;
  color: #687180;
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.08em;
  white-space: nowrap;
}

.nuvio-login-card {
  max-width: 980px;
  min-height: 560px;
  grid-template-columns: 52% 48%;
  border-radius: 30px;
  background: rgba(255, 255, 255, 0.9);
  box-shadow: 0 24px 70px rgba(25, 31, 40, 0.14);
}

.nuvio-brand-panel {
  padding: 50px;
  overflow: hidden;
  align-items: flex-start;
  background: #66508e;
}

.nuvio-brand-copy {
  max-width: 360px;
  margin-top: 26px;
}

.nuvio-panel-logo {
  width: 190px;
  height: auto;
  display: block;
  margin-bottom: 14px;
}

.nuvio-brand-panel p {
  margin: 0;
  color: antiquewhite;
  font-size: 13px;
  font-weight: 650;
  letter-spacing: 0.09em;
}

.nuvio-brand-panel h3 {
  max-width: 310px;
  margin: 34px 0 0;
  color: white;
  font-size: 28px;
  line-height: 1.18;
  font-weight: 780;
  letter-spacing: -0.045em;
}

.nuvio-brand-points {
  margin-top: 28px;
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.nuvio-brand-points span {
  padding: 7px 11px;
  border: 1px solid rgba(183, 192, 206, 0.72);
  border-radius: 999px;
  color: #525b68;
  font-size: 11px;
  font-weight: 700;
  background: rgba(255, 255, 255, 0.62);
}

.nuvio-movie-watermark {
  right: 76px;
  top: 48px;
  bottom: auto;
  width: 190px;
  height: 190px;
  opacity: 0.04;
}

.nuvio-auth-panel {
  padding: 15px 54px;
}

.nuvio-auth-heading {
  margin-bottom: 20px;
}

.nuvio-auth-heading h2 {
  font-size: 27px;
}

.nuvio-auth-heading p {
  margin: 7px 0 0;
  color: #788292;
  font-size: 12px;
  line-height: 1.45;
  font-weight: 550;
}

.nuvio-auth-switch {
  height: 38px;
  margin-bottom: 20px;
}

.nuvio-switch-btn {
  height: 30px;
}

.nuvio-pin-fields {
  gap: 14px;
}

.nuvio-pin-input,
.nuvio-input-shell input {
  height: 42px;
  border-radius: 13px;
}

.nuvio-pin-pad {
  margin-top: 16px;
  gap: 10px;
}

.nuvio-key {
  height: 44px;
  border-radius: 10px;
  background: linear-gradient(180deg, #ffffff, #f8fafc);
}

.nuvio-key-muted {
  background: #f3f6fa;
}

.nuvio-primary-btn {
  height: 42px;
  margin-top: 16px;
  border-radius: 999px;
}

@media (max-width: 900px) {
  .nuvio-login-card {
    max-width: 620px;
    grid-template-columns: 1fr;
  }

  .nuvio-brand-panel {
    min-height: 260px;
  }
}

@media (max-width: 640px) {
  .nuvio-brand-logo {
    width: 94px;
  }

  .nuvio-brand-subtitle {
    display: none;
  }

  .nuvio-login-card {
    border-radius: 22px;
  }

  .nuvio-brand-panel,
  .nuvio-auth-panel {
    padding: 15px 24px;
  }
}
.nuvio-login-page {
  position: relative;
  overflow: hidden;
  background: #ffffff;
}

.nuvio-login-page::before {
  content: "";
  position: absolute;
  inset: 0;
  background-image: none;
  background-repeat: no-repeat;
  background-position: right 4% bottom -34px;
  background-size: 330px auto;
  opacity: 0.055;
  pointer-events: none;
}

.nuvio-login-shell {
  position: relative;
  z-index: 1;
}

.nuvio-login-header {
  width: 100%;
}

.nuvio-header-brand {
  justify-content: flex-start;
}

.nuvio-header-client {
  margin-left: auto;
  justify-content: flex-end;
}

.nuvio-app-status {
  height: 28px;
  padding: 0 11px;
  border: 1px solid #e3e7ee;
  border-radius: 999px;
  color: #566070;
  font-size: 11px;
  font-weight: 700;
  background: rgba(255, 255, 255, 0.82);
  display: flex;
  align-items: center;
  white-space: nowrap;
}

.nuvio-app-status span {
  width: 7px;
  height: 7px;
  margin-right: 7px;
  border-radius: 50%;
  background: #22c55e;
}

.nuvio-app-status.is-demo span {
  background: #f59e0b;
}

.nuvio-brand-points span:nth-child(1) {
  background: rgba(255, 255, 255, 0.56);
}

.nuvio-brand-points span:nth-child(2) {
  background: rgba(255, 246, 237, 0.78);
}

.nuvio-brand-points span:nth-child(3) {
  background: rgba(247, 250, 252, 0.68);
}

.nuvio-auth-panel {
  background: radial-gradient(
      circle at right 12%,
      rgba(254, 242, 232, 0.7),
      transparent 23%
    ),
    rgba(255, 255, 255, 0.97);
}

.nuvio-auth-heading h2 {
  text-transform: none;
}

.nuvio-auth-switch {
  background: #f8f3ef;
}

.nuvio-switch-btn.active {
  background: var(--blue);
}

.nuvio-pin-pad {
  gap: 12px;
}

.nuvio-key {
  width: 46px;
  height: 46px;
  margin: 0 auto;
  border-radius: 50%;
  padding: 0;
}

.nuvio-key-muted {
  background: #fff8f2;
}

.nuvio-primary-btn {
  background: var(--blue);
}

.nuvio-primary-btn:hover,
.nuvio-primary-btn:focus {
  background: #111827;
}

@media (max-width: 640px) {
  .nuvio-login-page::before {
    background-size: 220px auto;
  }

  .nuvio-app-status {
    display: none;
  }
}
.nuvio-login-page::before {
  display: none;
}

.nuvio-page-watermark {
  position: absolute;
  fill: none;
  stroke: #f1cdb6;
  stroke-width: 4;
  stroke-linecap: round;
  stroke-linejoin: round;
  opacity: 0.5;
  pointer-events: none;
}

.nuvio-page-watermark-movie {
  width: 149px;
  height: 180px;
  bottom: -190px;
  right: 0;
  opacity: 0.1;
}

.nuvio-page-watermark-popcorn {
  width: 140px;
  height: 144px;
  left: 0;
  bottom: -210px;
  opacity: 0.1;
}

.nuvio-movie-watermark {
  display: none !important;
}

.nuvio-login-shell {
  max-width: 100%;
}

.nuvio-login-card {
  max-width: 960px;
  min-height: 545px;
}

.nuvio-org-logo,
.nuvio-org-fallback,
.nuvio-app-status,
.nuvio-env-badge {
  border: 0;
  box-shadow: none;
}

.nuvio-org-logo,
.nuvio-org-fallback {
  background: transparent;
}

.nuvio-app-status,
.nuvio-env-badge {
  background: transparent;
}

.nuvio-brand-panel h3 {
  max-width: 360px;
}

.nuvio-brand-points span {
  border: 0;
  color: #5c6471;
  background: rgba(255, 255, 255, 0.54);
}

.nuvio-brand-points span::before {
  content: "";
  width: 6px;
  height: 6px;
  margin-right: 7px;
  display: inline-block;
  border-radius: 50%;
  background: var(--blue);
  opacity: 0.72;
}

.nuvio-auth-heading h2 {
  font-weight: 550;
}

.nuvio-auth-switch {
  background: #ffffff;
}

.nuvio-switch-btn.active {
  background: var(--blue);
}

.nuvio-key {
  width: 100%;
  height: 42px;
  border-radius: 10px;
  background: #ffffff;
}

.nuvio-key-muted {
  background: #ffffff;
}

.nuvio-primary-btn {
  background: var(--blue);
}

.nuvio-primary-btn:hover,
.nuvio-primary-btn:focus {
  background: var(--blue);
  filter: brightness(0.94);
}

.nuvio-pin-input:focus,
.nuvio-pin-input.active,
.nuvio-input-shell input:focus {
  border-color: var(--blue);
  box-shadow: 0 0 0 3px rgba(18, 44, 106, 0.08);
}

@media (max-width: 1024px) {
  .nuvio-login-shell {
    padding: 16px 18px;
  }

  .nuvio-login-card {
    max-width: 900px;
    min-height: 500px;
  }

  .nuvio-brand-panel,
  .nuvio-auth-panel {
    padding: 34px;
  }

  .nuvio-brand-panel h3 {
    font-size: 24px;
  }
}

@media (max-height: 720px) {
  .nuvio-login-shell {
    padding-top: 14px;
    padding-bottom: 14px;
  }

  .nuvio-login-main {
    padding: 6px 0;
  }

  .nuvio-login-card {
    min-height: 465px;
  }

  .nuvio-brand-panel,
  .nuvio-auth-panel {
    /*padding-top: 15px;*/
    padding-bottom: 22px;
  }

  .nuvio-panel-logo {
    width: 165px;
  }

  .nuvio-brand-panel h3 {
    margin-top: 24px;
  }

  .nuvio-pin-pad {
    gap: 8px;
  }

  .nuvio-key {
    height: 38px;
  }
}

@media (max-width: 760px) {
  .nuvio-page-watermark {
    opacity: 0.28;
  }

  .nuvio-login-card {
    grid-template-columns: 1fr;
  }

  .nuvio-brand-panel {
    min-height: 220px;
    border-right: 0;
    border-bottom: 1px solid #e3e8f0;
  }
}

@media (max-width: 520px) {
  .nuvio-header-client {
    gap: 4px;
  }

  .nuvio-env-badge {
    display: none;
  }

  .nuvio-org-logo,
  .nuvio-org-fallback {
    width: 104px;
  }

  .nuvio-brand-panel,
  .nuvio-auth-panel {
    padding: 15px;
  }

  .nuvio-brand-panel h3 {
    font-size: 21px;
  }
}
.nuvio-login-main,
.nuvio-login-card,
.nuvio-auth-panel {
  transition: padding 0.22s ease, margin 0.22s ease, top 0.22s ease;
}

.nuvio-keyboard-open .nuvio-login-main {
  align-items: center;
  padding-top: 0;
  padding-bottom: 285px;
}

.nuvio-keyboard-open .nuvio-login-card {
  position: relative;
  top: -42px;
  transform: none;
}

.nuvio-keyboard-open .nuvio-auth-panel {
  justify-content: flex-start;
}

.nuvio-keyboard-open .nuvio-auth-heading {
  margin-bottom: 12px;
}

.nuvio-keyboard-open .nuvio-auth-heading p {
  display: none;
}

.nuvio-keyboard-open .nuvio-brand-panel {
  min-height: 0;
}

.nuvio-login-page .vKeyboard-container {
  z-index: 2400;
}

@media (max-height: 720px) {
  .nuvio-keyboard-open .nuvio-login-header {
    display: none;
  }

  .nuvio-keyboard-open .nuvio-login-card {
    top: 0;
    transform: none;
    min-height: auto;
  }

  .nuvio-keyboard-open .nuvio-brand-panel {
    display: none;
  }

  .nuvio-keyboard-open .nuvio-login-main {
    padding-bottom: 245px;
  }
}

@media (max-height: 640px) {
  .nuvio-keyboard-open .nuvio-login-main {
    padding-bottom: 205px;
  }

  .nuvio-keyboard-open .nuvio-auth-panel {
    padding-top: 18px;
    padding-bottom: 18px;
  }

  .nuvio-keyboard-open .nuvio-auth-switch {
    margin-bottom: 12px;
  }
}
.nuvio-pin-form,
.nuvio-credential-form {
  height: 288px;
  min-height: 288px;
}

.nuvio-pin-form {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
}

.nuvio-pin-fields {
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 16px;
  max-width: 100%;
  margin: 0;
}

.nuvio-pin-fields > div:first-child {
  justify-self: start;
}

.nuvio-pin-fields > div:last-child {
  justify-self: end;
}

.nuvio-pin-box-wrap {
  position: relative;
  width: fit-content;
  height: 32px;
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 4px;
  cursor: text;
}

.nuvio-pin-native-input {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  border: 0;
  opacity: 0;
  cursor: text;
}

.nuvio-pin-digit-box {
  width: 30px;
  height: 32px;
  border: 1px solid #d8dee8;
  border-radius: 7px;
  color: #20242b;
  font-size: 15px;
  font-weight: 750;
  line-height: 30px;
  text-align: center;
  background: #ffffff;
  transition: border-color 0.16s ease, box-shadow 0.16s ease,
    background 0.16s ease;
}

.nuvio-pin-digit-box.focused {
  border-color: var(--blue);
  box-shadow: 0 0 0 2px rgba(18, 44, 106, 0.1);
}

.nuvio-pin-digit-box.filled {
  background: #f8fafc;
}

.nuvio-pin-pad {
  margin-top: 10px;
}

.nuvio-primary-btn {
  min-height: 42px;
  margin-top: 10px;
  margin-bottom: 10px;
}

.nuvio-auth-panel {
  min-height: 400px;
}

@media (max-height: 720px) {
  .nuvio-pin-form,
  .nuvio-credential-form {
    height: 270px;
    min-height: 270px;
  }

  .nuvio-auth-panel {
    min-height: 370px;
  }

  .nuvio-pin-digit-box {
    width: 28px;
    height: 30px;
  }

  .nuvio-pin-digit-box {
    line-height: 28px;
  }
}

.nuvio-credential-form {
  gap: 10px;
}

.nuvio-credential-form .nuvio-primary-btn {
  margin-top: 4px;
}

.nuvio-input-group {
  margin-bottom: 0 !important;
}

.nuvio-input-shell input {
  height: 40px;
}

.nuvio-auth-panel {
  min-height: 390px;
  padding: 0px 54px 32px;
}

.nuvio-auth-heading {
  margin-bottom: 14px;
}

.nuvio-auth-heading p {
  margin-top: 4px;
}

.nuvio-auth-switch {
  margin-bottom: 14px;
}

.nuvio-pin-form,
.nuvio-credential-form {
  height: 264px;
  min-height: 264px;
}

.nuvio-credential-form {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.nuvio-credential-form .nuvio-primary-btn {
  margin-top: 6px;
  margin-bottom: 14px;
}

.nuvio-pin-fields {
  margin-bottom: 0;
}

.nuvio-pin-pad {
  margin-top: 12px;
  gap: 8px;
}

.nuvio-key {
  height: 40px;
}

.nuvio-pin-form .nuvio-primary-btn {
  margin-top: 12px;
  margin-bottom: 14px;
}

@media (max-height: 720px) {
  .nuvio-auth-panel {
    min-height: 360px;
    /*padding-top: 15px;*/
    padding-bottom: 24px;
  }

  .nuvio-pin-form,
  .nuvio-credential-form {
    height: 250px;
    min-height: 250px;
  }

  .nuvio-key {
    height: 38px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/posLogin.vue